
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_1iw3b_185",
  "grid": "awsui_grid_vj6p7_1iw3b_220",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_1iw3b_226",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_1iw3b_230",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_1iw3b_238",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_1iw3b_241",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_1iw3b_241",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_1iw3b_244",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_1iw3b_247",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_1iw3b_253",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_1iw3b_259",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_1iw3b_275",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_1iw3b_308",
  "root": "awsui_root_vj6p7_1iw3b_358",
  "tile-container": "awsui_tile-container_vj6p7_1iw3b_396",
  "refresh": "awsui_refresh_vj6p7_1iw3b_421",
  "has-metadata": "awsui_has-metadata_vj6p7_1iw3b_425",
  "selected": "awsui_selected_vj6p7_1iw3b_431",
  "disabled": "awsui_disabled_vj6p7_1iw3b_436",
  "readonly": "awsui_readonly_vj6p7_1iw3b_441",
  "columns": "awsui_columns_vj6p7_1iw3b_447",
  "column-1": "awsui_column-1_vj6p7_1iw3b_453",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_1iw3b_460",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_1iw3b_464",
  "column-2": "awsui_column-2_vj6p7_1iw3b_468",
  "column-3": "awsui_column-3_vj6p7_1iw3b_483",
  "column-4": "awsui_column-4_vj6p7_1iw3b_498",
  "control": "awsui_control_vj6p7_1iw3b_514",
  "no-image": "awsui_no-image_vj6p7_1iw3b_518",
  "image": "awsui_image_vj6p7_1iw3b_522"
};
  